module.exports = __webpack_public_path__ + "img/key_west2.75b5ef93.jpg";